import { Injectable } from '@angular/core';
import { HelperService } from '@sb-tools/typescript/services/helper.service';

@Injectable({
    providedIn: 'root',
})
export class LocalStorageService {
    isLocalStorageSupported: boolean;
    storageData: string[] = [];

    constructor() {
        this.isLocalStorageSupported = HelperService.isLocalStorageNameSupported();
        console.log('Local storage is supported ', this.isLocalStorageSupported);
    }

    getItem(key: string): string {
        if (this.isLocalStorageSupported) {
            return localStorage.getItem(key);
        } else {
            return this.storageData[key] || null;
        }
    }

    removeItem(key: string): void {
        if (this.isLocalStorageSupported) {
            localStorage.removeItem(key);
        } else {
            delete this.storageData[key];
        }
    }

    setItem(key: string, value: string): void {
        if (this.isLocalStorageSupported) {
            localStorage.setItem(key, value);
        } else {
            this.storageData[key] = String(value);
        }
    }
}
